import router from './router'
import store from './store'
import Vue from 'vue'
import {
  Message
} from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  getToken
} from '@/utils/auth'
import {
  isWeixin
} from "@/utils/utils";

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const whiteList = [
  '/', '/home', '/networking/home',
  '/networking/skillscompetition/0', '/networking/skillscompetition/1',
  '/networking/skillslist/0', '/networking/skillslist/1', '/networking/skillslist/2', '/networking/skillslist/3', '/networking/skillslist/4',
  '/networking/skillslist/5', '/networking/skillslist/6',
  '/networking/liveclass',
  '/networking/expertteam',
  '/networking/detail',
  '/course',
  
  '/networkingsingup/index', '/networkingsingup/project',
  '/exams', '/exam-details',
  // '/signup-details',
   '/signup',
   '/signup-form', '/choosegroup', '/communicationgroup',
  '/registrationends', '/courses', '/course-details', '/register', '/static', '/login',
  '/wxLogin', '/auth-redirect', '/404', '/401', '/lock', '/reset-password','/courseModel',
] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // 进度条
  if (to.path.indexOf('/mobile') !== -1) {
    next()
  } else if (getToken()) { // 判断是否已登录
    if (to.path === '/login' || to.path === '/register') {
      next({
        path: '/'
      })
    } else {
      const userInfo = store.getters.userInfo
      if (Object.keys(userInfo).length === 0) { // 判断当前用户是否已拉取完user_info信息
        store.dispatch('GetUserInfo').then(res => { // 拉取user_info
          next({
            ...to,
            replace: true
          }) // hack方法 确保addRoutes已完成
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({
              path: '/'
            })
          })
        })
        // 获取系统配置信息
        const sysConfig = store.getters.sysConfig
        if (Object.keys(sysConfig).length === 0) {
          store.dispatch('GetSysConfig').then(res => {}).catch(() => {
            console.log('获取系统配置失败！')
          })
        }
      } else {
        next()
      }
    }
    NProgress.done()
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      if (isWeixin()) {
        next(`/wxLogin?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      } else {
        //next('/login') // 重定向到登录页
        // next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页

         // 触发全局事件，显示登录弹窗
      Vue.prototype.$bus && Vue.prototype.$bus.emit('show-login', to.fullPath)
      next(false) // 阻止路由跳转
      }

      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
